var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/**
 * Footer component.
 * Renders a footer with copyright information.
 */
import styles from "./Footer.module.css";
var Footer = function () {
    var currentYear = new Date().getFullYear();
    return (_jsx("footer", __assign({ className: styles.container }, { children: _jsxs("div", __assign({ className: styles.inner }, { children: ["All rights reserved \u00A9 ", currentYear, " "] })) })));
};
export default Footer;
